import * as _f_ from "@Funciones/funciones";

export function SpinnerHTML({ mensaje, color = "#ffffff", estilos = {} }) {
  return (
    <div className={`anim-spinner-container`} style={_f_.estilosObjetoVariablesCSS(estilos)}>
      <div className="anim-spinner" style={{ borderTopColor: color }}></div>
      {mensaje && <span className="anim-spinner-texto">{mensaje}</span>}
    </div>
  );
}
